import React, { useState, useEffect } from 'react'
import { Dimensions } from 'react-native'

interface DimensionsCallbackProp {
	screen: { width: number; height: number }
}

export const useScreenDimensions = (): { width: number; height: number } => {
	const initialDimensions = Dimensions.get('screen')
	const [width, setWidth] = useState(initialDimensions.width)
	const [height, setHeight] = useState(initialDimensions.height)

	useEffect(() => {
		const handleChange = ({ screen }: DimensionsCallbackProp) => {
			setWidth(screen.width)
			setHeight(screen.height)
		}

		Dimensions.addEventListener('change', handleChange)
	})

	return { width, height }
}
